const callToActionStrings = {
  ActNow: _TL_('Act Now'),
  ApplyNow: _TL_('Apply Now'),
  BetNow: _TL_('Bet Now'),
  BidNow: _TL_('Bid Now'),
  BookACar: _TL_('Book A Car'),
  BookHotel: _TL_('Book Hotel'),
  BookNow: _TL_('Book Now'),
  BuildNow: _TL_('Build Now'),
  BuyNow: _TL_('Buy Now'),
  ChatNow: _TL_('Chat Now'),
  Compare: _TL_('Compare'),
  ContactUs: _TL_('Contact Us'),
  Dealers: _TL_('Dealers'),
  Directions: _TL_('Directions'),
  Donate: _TL_('Donate'),
  Download: _TL_('Download'),
  EmailNow: _TL_('Email Now'),
  EnrollNow: _TL_('Enroll Now'),
  FileNow: _TL_('File Now'),
  FindJob: _TL_('Find Job'),
  FindStore: _TL_('Find Store'),
  FreePlay: _TL_('Free Play'),
  FreeQuote: _TL_('Free Quote'),
  FreeTrial: _TL_('Free Trial'),
  Coupon: _TL_('Get Coupon'),
  GetDeals: _TL_('Get Deals'),
  GetDemo: _TL_('Get Demo'),
  GetNow: _TL_('Get Now'),
  GetOffer: _TL_('Get Offer'),
  GetQuote: _TL_('Get Quote'),
  GoToDemo: _TL_('Go To Demo'),
  JoinNow: _TL_('Join Now'),
  LearnMore: _TL_('Learn More'),
  ListenNow: _TL_('Listen Now'),
  LogIn: _TL_('Log In'),
  OrderNow: _TL_('Order Now'),
  PlayGame: _TL_('Play Game'),
  PlayNow: _TL_('Play Now'),
  PostJob: _TL_('Post Job'),
  Register: _TL_('Register'),
  RenewNow: _TL_('Renew Now'),
  RentACar: _TL_('Rent A Car'),
  RentNow: _TL_('Rent Now'),
  Reorder: _TL_('Reorder'),
  Reserve: _TL_('Reserve'),
  SaveNow: _TL_('Save Now'),
  Schedule: _TL_('Schedule'),
  SeeDemo: _TL_('See Demo'),
  SeeMenu: _TL_('See Menu'),
  SeeModels: _TL_('See Models'),
  SeeOffer: _TL_('See Offer'),
  SeeOffers: _TL_('See Offers'),
  Sale: _TL_('See Sale'),
  SellNow: _TL_('Sell Now'),
  ShopNow: _TL_('Shop Now'),
  Showtimes: _TL_('Showtimes'),
  SignIn: _TL_('Sign In'),
  SignUp: _TL_('Sign Up'),
  StartNow: _TL_('Start Now'),
  Subscribe: _TL_('Subscribe'),
  SwitchNow: _TL_('Switch Now'),
  TestDrive: _TL_('Test Drive'),
  TryNow: _TL_('Try Now'),
  ViewCars: _TL_('View Cars'),
  ViewDemo: _TL_('View Demo'),
  ViewPlans: _TL_('View Plans'),
  VisitStore: _TL_('Visit Store'),
  VoteNow: _TL_('Vote Now'),
  Watch: _TL_('Watch'),
  WatchMore: _TL_('Watch More'),
  WatchNow: _TL_('Watch Now'),
};

export const getLocalizedCallToActionString = (callToAction: string, i18n: any): string => {
  const mappedCallToAction = callToActionStrings[callToAction];
  if (mappedCallToAction) {
    return i18n.getString(mappedCallToAction);
  }
  return callToAction;
};
